import React, { useEffect, useState } from "react";
import { formatDate } from "../../../../utilities/formatDate";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "primereact/button";
import localeText from "../../../../locale";
import { formatPrice } from "../../../../utilities/formatPrice";
import { AdvancedImage } from "@cloudinary/react";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { fill } from "@cloudinary/url-gen/actions/resize";
import ThankyouCard from "./ThankyouCard";

export const formatAddress = (order) => {
  return `${order.address ? order.address + ", " : ""}${order.number ? order.number + ", " : ""}${
    order.district ? order.district + ", " : ""
  }${order.city ? order.city + ", " : ""}${order.state ? order.state + ", " : ""}${
    order.postalCode ? order.postalCode + ", " : ""
  }${order.country ? order.country : ""}`;
};

const isNumber = (value) => {
  return !isNaN(value) && typeof value === "number";
};

const ThankYouPage = ({ order, currencyCodeUser, amountTransfer }) => {
  const history = useHistory();
  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const anyProductIsPickup = order?.itens?.some(
    (product) => product?.product?.shippingOption === "PICKUP"
  );

  const handleRedicrectToMyPurchases = () => {
    history.push(
      isFringeBenefitsPage ? "/dashboard-purchases-fringe-benefit" : "/dashboard-purchases"
    );
  };

  const handleRedicrectToHome = () => {
    history.push(isFringeBenefitsPage ? "/fringe-benefits?search=ALL&currency=ALL&area=ALL" : "/");
  };

  const amountShipment = order?.amountShipment ? order.amountShipment : 0;
  const totalPrice = order.amountTotal + amountShipment;
  const productIsDownloadable = order?.itens?.some((product) => product?.product?.downloadable);

  return (
    <div className="flex flex-column mt-6 mb-8">
      <div className="text-center  mb-4">
        <div className="font-bold text-2xl" style={{ color: "#46A748" }}>
          {localeText("paymentFinished")}
        </div>

        <div className="text-sm mt-2">{localeText("yourOrderWillBeReady")}</div>
      </div>

      <div
        className="card border-none"
        style={{ backgroundColor: "#ffffff", boxShadow: "0px 0px 40px  #5F58521A" }}
      >
        <div className="font-bold" style={{ color: "#344563" }}>
          {localeText("paymentDone")}
        </div>
        <hr></hr>
        <div className="flex flex-column gap-2" style={{ color: "#344563" }}>
          <div className="flex justify-content-between">
            <div className="text-sm font-bold">{localeText("subtotal")}</div>
            <div className="text-sm font-semibold">
              {currencyCodeUser}{" "}
              {formatPrice(isFringeBenefitsPage ? order.totalOrder : order.amountTotal)}
            </div>
          </div>
          <div className="flex justify-content-between">
            <div className="text-sm font-bold">{localeText("shippingInfo")}</div>
            <div className="text-sm font-semibold">
              {currencyCodeUser} {formatPrice(amountShipment)}
            </div>
          </div>
        </div>
        <hr></hr>
        <div className="flex justify-content-between" style={{ color: "#344563" }}>
          <div className="text-sm font-bold">{localeText("totalAmount")}</div>
          <div className="font-bold">
            {currencyCodeUser} {formatPrice(isFringeBenefitsPage ? order.totalOrder : totalPrice)}
          </div>
        </div>
      </div>

      <div
        className="card border-none"
        style={{ backgroundColor: "#ffffff", boxShadow: "0px 0px 40px  #5F58521A" }}
      >
        <div>
          <div className="font-bold" style={{ color: "#344563" }}>
            {localeText("orderDetailsCart")}
          </div>
        </div>
        <div className="text-sm font-light mt-2">
          {localeText("someItensMightBeDeliveredSeparately")}
        </div>
        <hr></hr>
        <div className="flex flex-column gap-4">
          {isFringeBenefitsPage ? (
            <ThankyouCard item={order} currencyCodeUser={currencyCodeUser} />
          ) : (
            <>
              {order.itens.map((item) => (
                <ThankyouCard key={item.id} item={item} currencyCodeUser={currencyCodeUser} />
              ))}
            </>
          )}
        </div>
        <hr></hr>
        <div style={{ color: "#344563" }}>
          <div className="font-bold">{localeText("invoiceAddress")}</div>
          <div className="text-sm mt-2">
            {order.buyer.firstname} {order.buyer.surname}
          </div>
          <div className="text-sm font-light" style={{ color: "#7A869A" }}>
            {formatAddress(order)}
          </div>
        </div>
      </div>

      <div className="flex justify-content-start gap-2">
        <Button
          label={localeText("backToHomePage")}
          outlined
          className="py-3 px-4 border-round-lg"
          icon="pi pi-arrow-left"
          style={{ color: "#28AB69" }}
          onClick={handleRedicrectToHome}
        />
        <Button
          label={localeText("goToMyShoppings")}
          style={{ color: "#208C56", backgroundColor: "#D9F7EC80" }}
          className="py-3 px-4 border-none border-round-lg"
          onClick={handleRedicrectToMyPurchases}
        />
      </div>
    </div>
  );
};

export default ThankYouPage;
